import { type MetaFunction } from '@remix-run/node'
import { LegalPageLayout } from '#app/components/legal/LegalPageLayout.tsx'

export const meta: MetaFunction = () => [
	{ title: 'Política de cookies | Asociación Síndrome PCDH19' },
]

const browserLinks = [
	{ name: 'Chrome', href: 'http://support.google.com/chrome/answer/95647?hl=es' },
	{
		name: 'Edge',
		href: 'https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09',
	},
	{
		name: 'Explorer',
		href: 'https://support.microsoft.com/es-es/help/278835/how-to-delete-cookie-files-in-internet-explorer',
	},
	{ name: 'Firefox', href: 'https://www.mozilla.org/es-ES/privacy/websites/#cookies' },
	{ name: 'Safari', href: 'https://support.apple.com/es-es/guide/safari/sfri11471/mac' },
	{ name: 'Opera', href: 'https://help.opera.com/en/latest/security-and-privacy/#clearBrowsingData' },
]

export default function PoliticaCookiesRoute() {
	return (
		<LegalPageLayout
			title="Política de cookies"
			intro="Conforme con la LSSI, el RGPD y la LOPDGDD, es obligado obtener el consentimiento expreso del usuario de las páginas web que usan cookies prescindibles antes de navegar por ellas."
		>
			<h2>INFORMACIÓN SOBRE COOKIES</h2>
			<p>
				Conforme con la Ley 34/2002, de 11 de julio, de servicios de la sociedad
				de la información y de comercio electrónico (LSSI), en relación con el
				Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de
				abril de 2016, General de Protección de Datos (RGPD) y la Ley Orgánica
				3/2018, de 5 de diciembre, de Protección de Datos y Garantía de los
				Derechos Digitales (LOPDGDD), es obligado obtener el consentimiento expreso
				del usuario de todas las páginas web que usan cookies prescindibles, antes
				de que este navegue por ellas.
			</p>

			<h2>¿QUÉ SON LAS COOKIES?</h2>
			<p>
				Las cookies y otras tecnologías similares tales como local shared objects,
				flash cookies o píxeles, son herramientas empleadas por los servidores Web
				para almacenar y recuperar información acerca de sus visitantes, así como
				para ofrecer un correcto funcionamiento del sitio.
			</p>
			<p>
				Mediante el uso de estos dispositivos se permite al servidor Web recordar
				algunos datos concernientes al usuario, como sus preferencias para la
				visualización de las páginas de ese servidor, nombre y contraseña,
				productos que más le interesan, etc.
			</p>

			<h2>COOKIES AFECTADAS POR LA NORMATIVA Y COOKIES EXCEPTUADAS</h2>
			<p>
				Según la directiva de la UE, las cookies que requieren el consentimiento
				informado por parte del usuario son las cookies de analítica y las de
				publicidad y afiliación, quedando exceptuadas las de carácter técnico y las
				necesarias para el funcionamiento del sitio web o la prestación de servicios
				expresamente solicitados por el usuario.
			</p>

			<h2>TIPOS DE COOKIES</h2>
			<h3>SEGÚN LA FINALIDAD</h3>
			<ul>
				<li>
					<strong>Cookies técnicas y funcionales:</strong> son aquellas que permiten
					al usuario la navegación a través de una página web, plataforma o
					aplicación y la utilización de las diferentes opciones o servicios que en
					ella existan.
				</li>
				<li>
					<strong>Cookies analíticas:</strong> son aquellas que permiten al
					responsable de las mismas el seguimiento y análisis del comportamiento de
					los usuarios de los sitios web a los que están vinculadas.
				</li>
				<li>
					<strong>Cookies publicitarias:</strong> son aquellas que permiten la
					gestión, de la forma más eficaz posible, de los espacios publicitarios que,
					en su caso, el editor haya incluido en una página web, aplicación o
					plataforma.
				</li>
				<li>
					<strong>Cookies de publicidad comportamental:</strong> recogen información
					sobre las preferencias y elecciones personales del usuario (retargeting)
					para permitir la gestión, de la forma más eficaz posible, de los espacios
					publicitarios.
				</li>
				<li>
					<strong>Cookies sociales:</strong> son establecidas por las plataformas de
					redes sociales en los servicios para permitirle compartir contenido con sus
					amigos y redes.
				</li>
				<li>
					<strong>Cookies de afiliados:</strong> permiten hacer un seguimiento de las
					visitas procedentes de otras webs, con las que el sitio web establece un
					contrato de afiliación.
				</li>
				<li>
					<strong>Cookies de seguridad:</strong> almacenan información cifrada para
					evitar que los datos guardados en ellas sean vulnerables a ataques
					maliciosos de terceros.
				</li>
			</ul>
			<h3>SEGÚN LA PROPIEDAD</h3>
			<ul>
				<li>
					<strong>Cookies propias:</strong> son aquellas que se envían al equipo
					terminal del usuario desde un equipo o dominio gestionado por el propio
					editor.
				</li>
				<li>
					<strong>Cookies de terceros:</strong> son aquellas que se envían al equipo
					terminal del usuario desde un equipo o dominio que no es gestionado por el
					editor, sino por otra entidad.
				</li>
			</ul>
			<h3>SEGÚN EL PLAZO DE CONSERVACIÓN</h3>
			<ul>
				<li>
					<strong>Cookies de sesión:</strong> son un tipo de cookies diseñadas para
					recabar y almacenar datos mientras el usuario accede a una página web.
				</li>
				<li>
					<strong>Cookies persistentes:</strong> son un tipo de cookies en el que los
					datos siguen almacenados en el terminal y pueden ser accedidos y tratados
					durante un período definido por el responsable de la cookie.
				</li>
			</ul>

			<h2>TRATAMIENTO DE DATOS PERSONALES</h2>
			<p>
				ASOCIACIÓN SINDROME PCDH19 es el Responsable del tratamiento de los datos
				personales del Interesado y le informa de que estos datos serán tratados de
				conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril
				de 2016 (RGPD).
			</p>
			<p>
				Fines del tratamiento: según se especifica en el apartado de cookies que se
				utilizan en este sitio web. Legitimación del tratamiento: salvo en los
				casos en los que resulte necesario para la navegación por la web, por
				consentimiento del interesado (art. 6.1.a RGPD). Criterios de conservación
				de los datos: según se especifica en el apartado de cookies utilizadas en la
				web.
			</p>
			<p>
				Comunicación de los datos: no se comunicarán los datos a terceros, excepto
				en cookies propiedad de terceros o por obligación legal.
			</p>
			<ul>
				<li>Derecho a retirar el consentimiento en cualquier momento.</li>
				<li>
					Derecho de acceso, rectificación, portabilidad y supresión de sus datos,
					y de limitación u oposición a su tratamiento.
				</li>
				<li>
					Derecho a presentar una reclamación ante la Autoridad de control
					(www.aepd.es) si considera que el tratamiento no se ajusta a la normativa
					vigente.
				</li>
			</ul>
			<p>
				Datos de contacto para ejercer sus derechos: ASOCIACIÓN SINDROME PCDH19.
				Calle Violín, 27 - 29620 Torremolinos (Málaga). E-mail:
				sociospcdh19@gmail.com.
			</p>
			<p>
				Datos de contacto del delegado de protección de datos: Consulting
				Normativo, S.L, C/ Ferraz 28, 2º izquierda, Madrid -
				dpd@consultingnormativo.es.
			</p>

			<h2>COOKIES UTILIZADAS EN ESTE SITIO WEB</h2>
			<h3>COOKIES CONTROLADAS POR EL EDITOR</h3>
			<div className="not-prose mt-5 overflow-x-auto rounded-2xl border border-slate-200">
				<table className="min-w-full divide-y divide-slate-200 text-sm">
					<thead className="bg-slate-50 text-left text-slate-700">
						<tr>
							<th className="px-4 py-3 font-semibold">Propiedad</th>
							<th className="px-4 py-3 font-semibold">Cookie</th>
							<th className="px-4 py-3 font-semibold">Finalidad</th>
							<th className="px-4 py-3 font-semibold">Plazo</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-slate-200 bg-white text-slate-700">
						<tr>
							<td className="px-4 py-3">pcdh19.com</td>
							<td className="px-4 py-3 font-medium">CH-prefers-color-scheme</td>
							<td className="px-4 py-3">Cookie necesaria para la utilización de las opciones y servicios del sitio web.</td>
							<td className="px-4 py-3">en un año</td>
						</tr>
						<tr>
							<td className="px-4 py-3">pcdh19.com</td>
							<td className="px-4 py-3 font-medium">CH-time-zone</td>
							<td className="px-4 py-3">Cookie necesaria para la utilización de las opciones y servicios del sitio web.</td>
							<td className="px-4 py-3">en un año</td>
						</tr>
						<tr>
							<td className="px-4 py-3">pcdh19.com</td>
							<td className="px-4 py-3 font-medium">csrf</td>
							<td className="px-4 py-3">Cookie necesaria para la utilización de las opciones y servicios del sitio web.</td>
							<td className="px-4 py-3">Sesión</td>
						</tr>
					</tbody>
				</table>
			</div>
			<h3>COOKIES DE TERCEROS</h3>
			<p>
				Los servicios de terceros son ajenos al control del editor. Los proveedores
				pueden modificar en todo momento sus condiciones de servicio, finalidad y
				utilización de las cookies.
			</p>
			<p>Proveedores externos de este sitio web: no se instalan cookies controladas por terceros.</p>

			<h2>PANEL DE CONFIGURACIÓN DE COOKIES</h2>
			<p>
				Desde este panel podrá configurar las cookies que el sitio web puede
				instalar en su navegador, excepto las cookies técnicas o funcionales que
				son necesarias para la navegación y la utilización de las diferentes
				opciones o servicios que se ofrecen.
			</p>

			<h2>CÓMO GESTIONAR LAS COOKIES DESDE EL NAVEGADOR</h2>
			<ul>
				<li>
					<strong>Eliminar las cookies del dispositivo:</strong> las cookies que ya
					están en un dispositivo se pueden eliminar borrando el historial del
					navegador.
				</li>
				<li>
					<strong>Gestionar las cookies específicas del sitio:</strong> para tener un
					control más preciso de las cookies específicas de cada sitio, los usuarios
					pueden ajustar su configuración de privacidad y cookies en el navegador.
				</li>
				<li>
					<strong>Bloquear las cookies:</strong> aunque la mayoría de los navegadores
					modernos se pueden configurar para evitar que se instalen cookies, algunos
					servicios y características pueden no funcionar correctamente.
				</li>
			</ul>

			<h2>CÓMO ELIMINAR LAS COOKIES DE LOS NAVEGADORES MÁS COMUNES</h2>
			<p>
				Puede consultar la información oficial de cada navegador en los siguientes
				enlaces:
			</p>
			<ul>
				{browserLinks.map(browser => (
					<li key={browser.name}>
						<a href={browser.href} target="_blank" rel="noopener noreferrer">
							{browser.name}
						</a>
					</li>
				))}
			</ul>
		</LegalPageLayout>
	)
}
